import React, { useState, Suspense } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIInputPW from 'components/input/inputPW';
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import UIUtils from "utils/UIUtils";
import StringUtil from 'utils/StringUtil';
import CommonUtil from 'utils/CommonUtil';
import message from "common/message/source/MessageSource";
import CodeDataStore from "common/codedata/store/CodeDataStore";
import UISelect from 'components/selectbox/UISelect';
import userStore from "common/user/store/UserStore";
import DaumPostcode from "react-daum-postcode";
import codeDataStore from "common/codedata/store/CodeDataStore";
import UIDatePicker, { DatePickerProps } from "components/datepicker";
import UIInputMask from 'components/input/UIInputMask';
import UI from "components/UI";
import DateUtil from "utils/DateUtil";
import TbComFile from "domain/main/com/file/TbComFile";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import ValidationUtil from "common/validation/util/ValidationUtil";

const DEF_INFO_ID = 'ID는 4~15자, 영문 소문자 또는 영문 소문자와 숫자 조합이어야 합니다.';

function ContentsContainer() {
    const location = useLocation();
    const receivedData = (location.state as any)?.data;
    const history = useHistory();

    // 회원가입 정보
    const [personNm, setPersonNm] = useState('');
    const [hpNo ,setHpNo] = useState('');
    const [confirmedLoginNm , setConfirmedLoginNm] = useState('');
   	const [userTpCd,setUserTpCd] = useState('');
   	const [useYn,setUseYn] = useState('true');
   	const [loginNm,setLoginNm] = useState('');
   	const [personId,setPersionId] = useState('');
   	const [persionNm,setPersionNm] = useState('');
   	const [creatDt ,setCreatDt] = useState('');
   	const [apprDate ,setApprDate] = useState('');
   	const [apprYn ,setApprYn] = useState('');
   	const [bizNo ,setBizNo] = useState('');
   	const [corpNm ,setCorpNm] = useState('');
   	const [deptNm ,setDeptNm] = useState('');
   	const [emailId ,setEmailId] = useState('');
   	const [emailDomain, setEmailDomain] = useState('');
   	const [emailSelect, setEmailSelect] = useState('');
   	const [emailApprYn ,setEmailApprYn] = useState('');
   	const [posiNm ,setPosiNm] = useState('');
   	const [userTpCdNm ,setUserTpCdNm] = useState('');
   	const [writngDt ,setWritngDt] = useState('');
   	const [emailApprDate ,setEmailApprDate] = useState('');
   	const [emailApprKey ,setEmailApprKey] = useState('');
   	const [loginPassword ,setLoginPassword] = useState('');
   	const [confirmPassword ,setConfirmPassword] = useState('');
    const [ofcTelNo1, setOfcTelNo1] = useState('02');
    const [ofcTelNo2, setOfcTelNo2] = useState('');
    const [ofcTelNo3, setOfcTelNo3] = useState('');
    const [totalRowCnt,setTotalRowCnt] = useState(0);
    const [showRowCnt,setShowRowCnt] = useState(20);
    const [searchOpt, setSearchOpt] = useState('1');
    const [searchText, setSearchText] = useState('');
    const loginForm = React.useRef<HTMLFormElement>(null);
    const [emailList,setEmailList] = useState<any[]>([]);

    // 기업등록
    const [corpSizeCd,setCorpSizeCd] = useState('');
    const [regCorpNm,setRegCorpNm] = useState('');
    const [induCd,setInduCd] = useState('');        //
    const [regBizNo,setRegBizNo] = useState('');
    const [corpRegNo,setCorpRegNo] = useState('');  //
    const [ceoNm,setCeoNm] = useState('');
    const [estaDate,setEstaDate] = useState(new Date());
    const [estaFormCd,setEstaFormCd] = useState('');
    const [corpZipCd,setCorpZipCd] = useState('');
    const [corpAddr1,setCorpAddr1] = useState('');
    const [corpAddr2,setCorpAddr2] = useState('');
    const [homepageUrl,setHomepageUrl] = useState('');
    const [checkDup, setCheckDup] = useState(false);

    const [loadFinish,setLoadFinish] = useState(false);
    const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
    const [bizFileInfoList, setBizFileInfoList] = React.useState<any[]>([]);

    //파일정보 선언
    const [bizLicFileValue] = useState(new TbComFile());

    // 폼체크 여부
    const [formCheck,setFormCheck] = useState(false);

    // 팝업
    const [modal1203IsOpen, setModal1203IsOpen] = useState(false);
    const [modal1205IsOpen, setModal1205IsOpen] = useState(false);
    const [modalPostIsOpen, setModalPostIsOpen] = useState(false);

    //파일업로드
    const [uploadId, setUploadId] = React.useState("");
    const [uploadIdBiz, setUploadIdBiz] = React.useState("");

    //파일업로드
    const onCreationCompleteBiz = function (uploadIdBiz: string) {
        setUploadIdBiz(uploadIdBiz);
    }

    //파일업로드 완료
    const onUploadCompleteBiz = () => {
        console.log("bizUpload");
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadIdBiz);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
        console.log("arrayNew " ,JSON.stringify(arrayNew));

        let fileInfos : {
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
        }[] = [];

        let fileInfo : {
            ORGINL_FILE_NM:string;
            STRE_FILE_NM:string;
            FILE_SIZE:number;
            STRE_PATH:string;
            FILE_EXTSN:string;
        };

        //파일등록 정보
        arrayNew?.map((item, index) => {
            if(item.status =="complete"){
                fileInfo = {
                    ORGINL_FILE_NM:item.originalName,
                    STRE_FILE_NM:item.uploadName,
                    FILE_SIZE:item.size,
                    STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
                    FILE_EXTSN:item.extension,
                }
                fileInfos.push(fileInfo);
            }
            console.log("biz_fileInfos : "+JSON.stringify(fileInfos));
        })
        setBizFileInfoList(fileInfos);
    }

    const onFileUploadBiz = () => {
        if(uploadIdBiz){
            window["RAONKUPLOAD"].Transfer(uploadIdBiz);
        }
    }

    const formId = "loginForm";

    const handleSelect = (e) => {
        if(e.target.name === 'ofctelNo1'){
            setOfcTelNo1(e.target.value);
        } else if(e.target.name === 'searchOpt'){
           setSearchOpt(e.target.value);
        } else if(e.target.name === 'showRowCnt'){  //페이지 건수별로 보기
           setShowRowCnt(e.target.value);
           // @ts-ignore
           IBSheet.disposeAll(true);
           ib.init.Cfg.PageLength = e.target.value;
           ib.create();

        }
    };

    //우편번호 찾기 스타일
    const postCodeStyle = {
        display: "block",
    };

    //우편번호 찾기 콜백
	const handleComplete = (data) => {
		setCorpZipCd(data.zonecode);
		setCorpAddr1(data.address);
		onClose('post');
	};




   /**
   * 아이디 중복 체크
   *
   */
    async function checkduplicatedId(event) {
        event.preventDefault();
        if (!/^[a-z0-9]{4,15}$/.test(loginNm)) {
            UIUtils.alert(DEF_INFO_ID).then();
            return;
        }

//         const loginNm = PersonManageModel.getTbSysUser().getLoginNm();
        if (loginNm == null || StringUtil.isEmpty(loginNm)) {
            UIUtils.alert("아이디를 입력해주세요").then();
            return;
        }

        const response:any = await CommonUtil.execute({
            url: "checkduplicatedId.jct",
            data: { "LOGIN_NM" : loginNm}
        })

        const result = response.TOTAL;

        if (result == null) {
          return;
        }

        if (result > 0) {
            UIUtils.alert(message.get("admin.appmanage.personmanage.checkDuplicatedId.failure", "중복된 아이디입니다.")).then();
            return;
          }else{
              UIUtils.alert(message.get("admin.appmanage.personmanage.checkDuplicatedId.success", "등록 가능한 아이디입니다.")).then();
              setConfirmedLoginNm(loginNm);
          }

    }

    //회원가입 진행
    async function onClickSave(event) {
        event.preventDefault();

        if(ValidationUtil.checkAll()) {
            // 검증이 유효하지 않은 경우
            return;
        }

        const createUserId = 'ANONYMOUS-USER-000';      // 임시
        const ofcTelNo = ofcTelNo1 + ofcTelNo2 + ofcTelNo3;
        const emailAdres = emailId + "@" + emailDomain;
        const userTpCd = 'N';

        if (await UIUtils.confirm("저장하시겠습니까?")) {

            let param = {
                PERSON_ID:personId
                ,LOGIN_NM : loginNm
                ,CREAT_USER_ID:createUserId
                ,EMAIL_ADRES:emailAdres
                ,PERSON_NM:personNm
                ,WRITNG_PSN_ID:""
                ,WRITNG_DT:writngDt
                ,BIZ_NO:bizNo
                ,DEPT_NM:deptNm
                ,POSI_NM:posiNm
                ,OFC_TEL_NO:ofcTelNo
                ,HP_NO:hpNo
                ,USER_TP_CD:"N"
                ,EMAIL_APPR_YN:""
                ,EMAIL_APPR_DATE:""
                ,EMAIL_APPR_KEY:""
                ,APPR_YN:""
                ,APPR_USERID:""
                ,APPR_DATE:""
                ,USE_YN:useYn
                ,EMAIL_ID: emailAdres                                                  // 수신자 메일
            }

            //if (confirmedLoginNm == null || (confirmedLoginNm != null && confirmedLoginNm !== personManageModel.getTbSysUser().getLoginNm())) {

            if (!/^[a-z0-9]{4,15}$/.test(loginNm)) {
                UIUtils.alert(DEF_INFO_ID).then();
                return;
            }

            if (confirmedLoginNm == null || confirmedLoginNm == "") {
                await UIUtils.alert("아이디 중복체크를 해주세요");
                return;
            }

            // 패스워드 일치 여부 서버에서 체크
            // if (loginPassword !== confirmPassword) {
            //     await UIUtils.alert("패스워드가 일치하지 않습니다");
            //     return;
            // }

            if (posiNm == null || posiNm == "") {
                await UIUtils.alert("직위를 입력해주세요");
                return;
            }

            if (deptNm == null || deptNm == "") {
                await UIUtils.alert("부서를 입력해주세요");
                return;
            }

            if (loginPassword == null || loginPassword == "") {
                await UIUtils.alert("비밀번호를 입력해주세요");
                return;
            }

            if (confirmPassword == null || confirmPassword == "") {
                await UIUtils.alert("비밀번호를 한번 더 입력해주세요");
                return;
            }

            // 사무실 전화번호
            if (ofcTelNo == null || ofcTelNo == "") {
                await UIUtils.alert("사무실 번호를 입력해주세요");
                return;
            }
            // 이메일
            if (emailAdres == null || emailAdres == "") {
                await UIUtils.alert("이메일을 입력해주세요");
                return;
            }

            // 기업명
            if (bizNo == null || bizNo == "") {
                await UIUtils.alert("기업명을 입력해주세요");
                return;
            }

            // console.log(param);

            const response:any = await CommonUtil.execute({
                url: "memberSign.jct",
                data: param,
                form : loginForm.current as HTMLFormElement,
            }).then((response:any) => {

                let vPERSON_ID = response;

                let dataToSend = {
                    vPERSON_ID
                }

                UIUtils.alert('회원가입이 완료되었습니다').then();

                // 상세페이지로 이동
                history.push({
                    pathname: '/main/usr_1000/usr_1204',
                    state: { data: dataToSend }
                })

            }).catch((error) => {
                CommonUtil.showAxiosError(error);
                return;
            });

        }

    };

	const modalusr1202 = useToggleState({});


    /////////////////// 기업 찾기 START //////////////////////////

    //초기 데이터 설정
    let totalCnt:number = 0;

    //====== 그리드 공통 부 START
    var ib = ib||{};
    ib = {
        //시트 초기화 구문
        'init':{
            "Cfg": {
                "SearchMode": 1,
                "PageLength": 20,
                "Alternate": 2,
                "AutoRowHeight": true,
                "InfoRowConfig": "0"
            },
                //틀고정 좌측 컬럼 설정
                "LeftCols": [
                {"Header": "No","Name": "SEQ","Width": "90"}
                ],
            "Cols": [
                {"Header": "기업명","Type": "Text","Name": "CORP_NM","RelWidth": 2,"Align": "Center","CanEdit": "0"},
                {"Header": "법인등록번호","Type": "Text","Name": "BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": "0"},
                {"Header": "사업자등록번호","Type": "Text","CustomFormat": "###-##-#####","Name": "BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": "0"},
                {"Header": "대표자명","Type": "Text","Name": "CEO_NM","RelWidth": 2,"Align": "Center","CanEdit": "0"},
                {"Header": "기업규모","Type": "Text","Name": "CORP_SIZE_CD_NM","RelWidth": 1.5,"Align": "Center","CanEdit": "0"},
            ]
        },
        //시트 이벤트
        'event':{
            onRenderFirstFinish:function (evtParam) {
                //초기 데이터 로딩
                doSearch('init');
            },
            // 클릭 이벤트
            onDblClick:function(evtParam){
                let sheet = evtParam.sheet;
                let row = sheet.getFocusedRow();
                let rowBizNo = row["BIZ_NO"];
                setBizNo(rowBizNo.toString());
                setCorpNm(row["CORP_NM"]);

                // 팝업 Close
                onClose('1203');
            },
            onBeforeDataLoad:function (evtParam) {
                // 조회 후 로딩 전 발생 이벤트
                var d = evtParam.data;
                var _data;

                // 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
                if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
                _data = JSON.stringify(d.slice(0, 20), null, 2);
                _data += _data.substring(0, _data.length - 1) + '...\n]';
                } else {
                _data = JSON.stringify(d, null, 2);
                }

            },
            onAfterGotoPage:function (evtParam) {

                var sheet = evtParam.sheet;
                var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
                //@ts-ignore
                if (currentPage != -1 && currentPage != page) {
                  makePageIndex(page);
                }

            }
        },
        //시트객체 생성
        'create':function () {
            let options = this.init;

            //@ts-ignore
            options.Events = this.event;
            //@ts-ignore
            IBSheet.create({
                id: 'sheet', // 생성할 시트의 id
                el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
                options: options, // 생성될 시트의 속성
                data: this.data // 생성될 시트의 정적데이터
            });
            // global 변수 선언
            //@ts-ignore
            window.currentPage = -1;
        },
        //화면 기능
        'sampleBtn':function (showRowCnt) {
            this.init.PageLength = showRowCnt;
            ib.create();
        },
        //조회 데이터
        'data':[]
    }

    //====== 그리드 공통 부  END

    //====== 그리드 데이터 가지고 오기  START
    async function doSearch(sAction:string) {
        let param = {};
        let popCorpNm = '';
        let popCorpRegNo = '';
        let popBizNo = '';
        if(sAction =='search'){

            if(searchOpt == '1'){
                popCorpNm = searchText;
            } else if(searchOpt == '2') {
                popCorpRegNo = searchText.replaceAll('-','');
            } else if(searchOpt == '3') {
                popBizNo = searchText.replaceAll('-','');
            }

           param = {
               "CORP_NM": popCorpNm,
               "CORP_REG_NO": popCorpRegNo,
               "BIZ_NO": popBizNo,
           };
        }
        console.log(param);

        const response:any = await CommonUtil.execute({
            url: 'adm_4200.jct',
            data: param
        });

//         console.log(param);

        //전체ROW개수
        totalCnt = Object.keys(response.REC).length;
        setTotalRowCnt(Object.keys(response.REC).length);
        //전체데이터
        let result = response.REC;
        // @ts-ignore
        if(typeof result == 'undefined'){
            alert('data is not loaded!!!')
            return;
        }

        //데이터 처리
        ib.data = result;

        // @ts-ignore
        sheet.loadSearchData(result);  //data 로딩 처리
        // @ts-ignore
        sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
        // @ts-ignore
        makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화

    }

    //====== 그리드 데이터 가지고 오기  END

    //====== 그리드 페이징 처리
    // @ts-ignore
    const makePageIndex = function (tp:number) {
      try {
        if (tp == null) {
            //@ts-ignore
            currentPage = -1;
            return;
        }

        // @ts-ignore
        if (document.getElementById('pageNavi').firstChild) {
          // @ts-ignore
          document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
        }

        // @ts-ignore
        currentPage = tp;
        // @ts-ignore
        let sr = totalCnt // 전체 조회 건수
        // @ts-ignore
        let page = showRowCnt; // 페이지당 레코드 수
        let thispage = tp; // 현재 페이지
        let pagecnt = 5; // 한번에 표시할 페이지 개수
        let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
        let li, tt, a;
        let ul = document.createElement('DIV');
        // @ts-ignore
        ul.style.textAlign = 'center';

        let k = 1;

        if (thispage !== 1) {
          let ul_sub = document.createElement('DIV');
          ul_sub.className ="group";
          li = document.createElement('Button');
          li.className = 'item first';
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          tt = document.createTextNode('<<');
          addEventHandler(li, 'click', pageMove, 1);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub.appendChild(li)
          ul.appendChild(ul_sub);

          li = document.createElement('Button');
          li.className = 'item prev';
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          addEventHandler(li, 'click', pageMove, tp - 1);
          tt = document.createTextNode('<');
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub.appendChild(li)
          ul.appendChild(ul_sub);
        }

        sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
        let ul_sub2 = document.createElement('DIV');
        ul_sub2.className ="group";
        for (let i = sr; i < (sr + pagecnt); i++) {
          if (i <= lastpage) {
            li = document.createElement('Button');
            li.className ="item";
            a = document.createElement('a');
            a.style.cursor = 'pointer';
            tt = document.createTextNode(String(i));
            addEventHandler(li, 'click', pageMove, i);
            if (i === tp) {
              li.className ="item active";
            }
            a.appendChild(tt);
            li.appendChild(a);
            ul_sub2.appendChild(li);
            ul.appendChild(ul_sub2);
          }
        }

        if (thispage < lastpage) {
          let ul_sub3 = document.createElement('DIV');
          ul_sub3.className ="group";
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          li = document.createElement('Button');
          li.className = 'item next';
          tt = document.createTextNode('>');
          addEventHandler(li, 'click', pageMove, tp + 1);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub3.appendChild(li);
          ul.appendChild(ul_sub3);

          li = document.createElement('Button');
          li.className = 'item last';
          tt = document.createTextNode('>>');
          a = document.createElement('a');
          a.style.cursor = 'pointer';
          addEventHandler(li, 'click', pageMove, lastpage);
          a.appendChild(tt);
          li.appendChild(a);
          ul_sub3.appendChild(li);
          ul.appendChild(ul_sub3);
        }

        ul.className = 'pg';
        // @ts-ignore
        document.getElementById('pageNavi').appendChild(ul);
      } catch (ex) {
        // @ts-ignore
        alert(ex.message);
      }
    }

    //페이지 이동
    // @ts-ignore
    const pageMove = function (cPage:number) {
      // @ts-ignore
      sheet.goToPageByIndex(cPage);

    }

    //페이지 이동 이벤트 핸들러
    // @ts-ignore
    const addEventHandler = function (obj, evtName, func, param) {
      if (obj.addEventListener) { // all browsers except IE before version 9
        obj.addEventListener(evtName, function () { func(param); }, false);
      } else if (obj.attachEvent) { // IE before version 9
        obj.attachEvent('on' + evtName, function () { func(param); });
      }
    }

    //인풋 엔터체크
    const activeEnter = (e) => {
        if(e.key === "Enter") {
            doSearch('search');
        }
    }

    /////////////////// 기업 찾기 END //////////////////////////

    // init
    React.useEffect(() => {
        // console.log(receivedData);
        if(receivedData == undefined){
            UIUtils.alert('잘못된 접근입니다.')
            .then(() => {
                history.push({pathname: '/main/usr_1000/usr_1200'});
            });
        } else {
            if(receivedData.hpNo == ''){
                UIUtils.alert('잘못된 휴대전화번호 길이 입니다.')
                    .then(() => {
                        history.push({pathname: '/main/usr_1000/usr_1200'});
                    });
            } else {
                setHpNo(receivedData.hpNo);
                setPersonNm(receivedData.name);
            }
        }

        //필요한 공통코드 로딩.
        CodeDataStore.read("/common/useYn", "[EVC]", "[EVDC]", "[SCS]", "[INC]", "[EFC]", "[EMAIL]")
        .then(() => {
            let email = CodeDataStore.get("[EMAIL]");
            setEmailList(email);
        });;
    },[])

    // 파일 업로드 성공여부 체크
    React.useEffect(() => {
        // 파일 업로드 성공여부 체크
        if( bizFileInfoList && formCheck) {
            let param = {
                BIZ_NO:regBizNo,
                CORP_REG_NO:corpRegNo,
                CORP_NM:regCorpNm,
                CEO_NM:ceoNm,
                CORP_SIZE_CD:corpSizeCd,
                INDU_CD:induCd,
                ESTA_DATE:DateUtil.toDateFormat(estaDate, "YYYY-MM-DD"),
                ESTA_FORM_CD:estaFormCd,
                CORP_ZIP_CD:corpZipCd,
                CORP_ADDR_1:corpAddr1,
                CORP_ADDR_2:corpAddr2,
                HOMEPAGE_URL:homepageUrl,
                FILE_INFO_LIST:fileInfoList.length>0?fileInfoList:null,
                BIZ_FILE_INFO_LIST:bizFileInfoList.length>0?bizFileInfoList:null,
            }
            console.log("param : "+JSON.stringify(param));
            corpCreate(param);
        }
    },[bizFileInfoList])

    // 팝업 Open > ibSheet init
    async function onAfterOpen() {
        ib.create()

        return () => {
          // @ts-ignore
            IBSheet.disposeAll(true);
        }
    }

    // 팝업 Close
    async function onClose(value) {
        if(value == '1203'){
            setModal1203IsOpen(false);
            setSearchText('');
            // @ts-ignore
            IBSheet.disposeAll(true);
        } else if(value == '1205'){
            setModal1205IsOpen(false);
        } else if(value == 'post'){
            setModalPostIsOpen(false);
        }
    }

    // 기업명 삭제
    const deleteBizNo = () => {
        setBizNo('');
        setCorpNm('');
    }

    // 취소 - 이전화면으로 이동
    const onClickCancel = () => {
        history.push({
            pathname: '/main/usr_1000/usr_1200',
            state: { data: {} }
        });
    }

    const alertModal = async () => {
        const value = await UIUtils.alert(<>
            필수 입력이 완료되지 않았습니다.<br/>
            다시 확인해 주세요.
        </>);
    }

    //기업 등록전 파일업로드 파라미터 체크
    async function corpFormCheck(){

        // 대표자명 , 업종, 설립일자, 설립형태, 기업규모, 주소, 사업자등록증, 기업로고
        if(ceoNm == "" || induCd == "" || estaFormCd == "" || corpSizeCd == "" || corpZipCd == "" || corpAddr1 == "" || corpAddr2 == ""  || bizLicFileValue.files.length < 1){
            await UIUtils.alert(<>필수 입력이 완료되지 않았습니다.<br/> 다시 확인해 주세요.</>);
            return;
        }

        if(await UIUtils.confirm('저장하시겠습니까?')){
            setFormCheck(true);  //폼 체크 여부
            onFileUploadBiz();
        }
    };

    //기업 등록
    async function corpCreate(param) {

        const response:any = await CommonUtil.execute({
            url:'usr_1202',
            data: param
        })
        .then((response: any) => {
            if(response.ERR_CD =="9999"){
                UIUtils.alert(response.ERR_MSG).then();
                return;
            }else{
                //초기화
                bizLicFileValue.tbComFileMapngDetailList = [];

                UIUtils.alert('저장되었습니다.').then();
                onClose('1205');
            }
        }).catch(err => {
            CommonUtil.showAxiosError(err);
            return;
        });



    }

    // 사업자 등록 번호 중복 체크
    async function dupCheck() {

        if(regBizNo == '' || regBizNo == null ){
            UIUtils.alert("사업자등록번호를 입력해주세요.").then();
            return;
        }

        var param = {BIZ_NO: regBizNo};

        const response:any = await CommonUtil.execute({
            url:'usr_1205',
            data: param
        })
        .then((response: any) => {
            if(response.ERR_CD =="9999"){
                UIUtils.alert(response.ERR_MSG).then();
                return;
            }else{
                UIUtils.alert("등록 가능한 사업자등록번호입니다.").then();
                setCheckDup(true);
            }
        }).catch(err => {
            CommonUtil.showAxiosError(err);
            return;
        });


    }

	return (
		<PageContainer session={false}>
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">회원가입</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<div className="member-join">
						<h1 className="tx tx-hd2">회원가입</h1>
						<ul className="join-step">
							<li>STEP 1. 약관동의 및 인증</li>
							<li className="active">STEP 2. 회원정보 입력</li>
							<li>STEP 3. 가입완료</li>
						</ul>
						<form className="fo fo-col2" id={formId} name={formId} ref={loginForm}>
							<div className="inner">
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">이름</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} value={personNm} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">직위</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} rules={["required"]} value={posiNm} placeholder={'직위를 입력하세요'} valueChanged={(value) => {setPosiNm(value)}}/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} rules={["required"]} value={deptNm} placeholder={'부서를 입력하세요.'} valueChanged={(value) => {setDeptNm(value)}}/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">아이디</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
											<div className="hz-root hz-gap8 w375">
												<UIInput className={'hz-item hz-fg tf tf-md'} rules={["required"]} value={loginNm} placeholder={'아이디를 입력 후 중복확인을 눌러주세요'} valueChanged={(value) => {setLoginNm(value)}}/>
												<Button color="gray-o" size="md" onClick={(e) => checkduplicatedId(e)}>중복 확인</Button>
											</div>
											<span className="tx-msg">{DEF_INFO_ID}</span>
										</div>
										
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">비밀번호</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
											<UIInputPW
                                                className={'tf tf-md w375'}
                                                placeholder={'비밀번호를 입력하세요'}
                                                attrs={{
                                                    name: "LOGIN_PASSWORD",
                                                    alt: "Password",
                                                    tabIndex: 1,
                                                    autoComplete: "on",
                                                }}
                                                readOnly={false}
                                                valueChanged={(value) => setLoginPassword(value)}
                                                rules={["required","password"]}
                                                focusClear={true}
                                            />
											<span className="tx-msg">※ 8~12자의 영문, 숫자, 특수문자 조합으로 입력해 주세요.</span>
										</div>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">비밀번호 확인</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8">
										    <UIInputPW
                                                className={'tf tf-md w375'}
                                                placeholder={'비밀번호를 다시 한번 더 입력하세요'}
                                                attrs={{
                                                    name: "CONFIRM_PASSWORD",
                                                    alt: "Password",
                                                    tabIndex: 2,
                                                    autoComplete: "on",
                                                }}
                                                readOnly={false}
                                                valueChanged={(value) => setConfirmPassword(value)}
                                                rules={["required","password"]}
                                                focusClear={true}
                                            />
										</div>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">사무실 전화</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w375">
											<div className="sl sl-md">
                                                <select name="ofctelNo1" id="ofctelNo1" className=""
                                                        onChange={handleSelect}>
                                                    <option value="02">02</option>
                                                    <option value="031">031</option>
                                                    <option value="032">032</option>
                                                    <option value="033">033</option>
                                                    <option value="041">041</option>
                                                    <option value="042">042</option>
                                                    <option value="043">043</option>
                                                    <option value="044">044</option>
                                                    <option value="051">051</option>
                                                    <option value="052">052</option>
                                                    <option value="053">053</option>
                                                    <option value="054">054</option>
                                                    <option value="055">055</option>
                                                    <option value="061">061</option>
                                                    <option value="062">062</option>
                                                    <option value="063">063</option>
                                                    <option value="064">064</option>
                                                    <option value="070">070</option>
                                                </select>
                                            </div>
                                            <span>-</span>
											<UIInput rules={["required","number"]} className={'hz-item hz-fg tf tf-md'} value={ofcTelNo2} placeholder={'0000'} valueChanged={(value) => setOfcTelNo2(value)}/>
											<span>-</span>
											<UIInput rules={["required","number"]} className={'hz-item hz-fg tf tf-md'} value={ofcTelNo3} placeholder={'0000'} valueChanged={(value) => setOfcTelNo3(value)}/>
										</div>
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">핸드폰번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w375'} value={hpNo} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w565">
											<UIInput
											    className={'hz-item hz-fg tf tf-md'}
                                                rules={["required"]}
											    value={emailId}
											    placeholder={'메일계정 입력'}
											    valueChanged={(value) => setEmailId(value)}
                                            />
											<span>@</span>
											<UIInput
											    className={'hz-item hz-fg tf tf-md'}
                                                rules={["required"]}
											    value={emailDomain}
											    valueChanged={(value) => setEmailDomain(value)}
											    attrs={{ readOnly: StringUtil.isNotEmpty(emailSelect), placeholder: "이메일 주소를 입력해주세요." }}
                                            />
											<div className="hz-item hz-fg sl sl-md">
											    <UISelect
                                                    className={'hz-item hz-fg tf tf-md'}
                                                    value={emailSelect}
                                                    valueChanged={(value) => {
                                                      if (StringUtil.isNotEmpty(value)) {
                                                        setEmailDomain(value);
                                                        setEmailSelect(value);
                                                      } else {
                                                        setEmailDomain("");
                                                        setEmailSelect("");
                                                      }
                                                      setEmailDomain(value);
                                                    }}
                                                    codeData={emailList}
                                                    firstName={"write"}
                                                  />
											</div>
										</div>
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<div className="hz-root hz-gap8 w565">
											<UIInput className={'hz-item hz-fg tf tf-md'} value={corpNm} placeholder={'기업명을 찾기 후 선택하세요'} readOnly={true}/>
											<Button color='pri-o' size="md"  onClick={() => setModal1203IsOpen(true)}>찾기</Button>
											<Button color='gray-o' size="md" onClick={() => deleteBizNo()}>삭제</Button>
 											<Button color='gray' size="md" onClick={() => setModal1205IsOpen(true)}>기업등록</Button>
										</div>
										<p className="tx-msg mt8"><span className="fc-pri">※ 소속기업 정보가 없을경우, 자체등록이 가능하나 기금을 출연하는 출연기업인 경우 재단담당자에게 기업등록 요청후, 회원가입 진행하시기 바랍니다.</span></p>
									</div>
								</div>
							</div>
						</form>
						<div className="hz-root hz-center hz-gap10">
							<Button color='gray-o' size="big" onClick={onClickCancel}>취소</Button>
							<Button color='pri' size="big" onClick={onClickSave}>저장</Button>
						</div>
					</div>
				</main>
			</div>
			{/* modal - 기업검색 */}
			<ModalPopup
				open={modal1203IsOpen}
				title="기업검색"
				size="mid"
				onClose={() => onClose('1203')}
				onAfterOpen={() => onAfterOpen()}
			>
				<div className="modal-con">
					<div className="tb-search-form bd mb30">
						<div className="hz-root hz-center hz-gap8">
							<div className="hz-item sl sl-md">
								<select name="searchOpt" id="searchOpt" onChange={handleSelect}>
									<option value="1">기업명</option>
									<option value="2">법인사업자번호</option>
									<option value="3">사업자등록번호</option>
								</select>
							</div>
							<UIInput className={'hz-item tf tf-md'} value={searchText} valueChanged={(value) => setSearchText(value)} placeholder={"입력하세요."} onKeyEnter={(e) => activeEnter(e)}/>
							<Button color="pri" size="md" onClick={(e) => doSearch('search')}>조회</Button>
						</div>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap8">
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
                                    <option value="20">20개씩보기</option>
                                    <option value="50">50개씩보기</option>
                                    <option value="100">100개씩보기</option>
                                    <option value="200">200개씩보기</option>
                                    <option value="500">500개씩보기</option>
                                    <option value="1000">1000개씩보기</option>
								</select>
							</div>									
						</div>
					</div>
					<div id="sheetDiv" ></div>
                    <div id="pageNavi" className="pg"></div>
				</div>
			</ModalPopup>
			{/* modal - 기업등록 */}
			<ModalPopup
                open={modal1205IsOpen}
                title="기업등록"
                size="xlg"
                onClose={() => onClose('1205')}
            >
                <div className="modal-con">
                    <div className="tx tx-cp2 ta-right mb8"><span className="fc-pri">*</span>&nbsp;필수 입력</div>
                    <form className="fo fo-col2" name="" action="" method="">
                        <div className="inner">
                            <div className="fo-item req">
                                <p className="fo-key">기업명</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'} value={regCorpNm} placeholder={'기업명'} valueChanged={(value) => setRegCorpNm(value)}/>
                                </div>
                            </div>
                            <div className="fo-item req">
                                <p className="fo-key">대표자명</p>
                                <div className="fo-value">
                                    <UIInput className={'tf tf-md w100p'} value={ceoNm} placeholder={'대표자명'} valueChanged={(value) => setCeoNm(value)}/>
                                </div>
                            </div>
                            <div className="fo-item req">
                                <p className="fo-key">업종</p>
                                <div className="fo-value">
                                    <div className="sl sl-md w100p">
                                        <UISelect
                                            firstName={"sel"}
                                            codeData={codeDataStore.get("[INC]")}
                                            value={induCd}
                                            valueChanged={(value) => setInduCd(String(value))}
                                            rules = {[(value: any) => {
                                                if (value == "선택") {
                                                    return `그룹을 선택해 주세요.`;
                                                }
                                                return undefined;
                                            }]}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="fo-item req">
                                <p className="fo-key">설립일자</p>
                                <div className="fo-value">
                                    <div className="w100p">
                                        <UIDatePicker value={estaDate} valueChanged={(value) => setEstaDate(value)} showToday={true}/>
                                    </div>
                                </div>
                            </div>
                            <div className="fo-item req">
                                <p className="fo-key">설립형태</p>
                                <div className="fo-value">
                                    <div className="sl sl-md w100p">
                                        <UISelect
                                            firstName={"sel"}
                                            codeData={codeDataStore.get("[EFC]")}
                                            value={estaFormCd}
                                            valueChanged={(value) => setEstaFormCd(String(value))}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="fo-item req">
                                <p className="fo-key">기업규모</p>
                                <div className="fo-value">
                                    <div className="sl sl-md w100p">
                                        <UISelect
                                            firstName={"sel"}
                                            codeData={codeDataStore.get("[SCS]")}
                                            value={corpSizeCd}
                                            valueChanged={(value) => setCorpSizeCd(String(value))}
                                            rules = {[(value: any) => {
                                                if (value == "선택") {
                                                    return `그룹을 선택해 주세요.`;
                                                }
                                                return undefined;
                                            }]}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="fo-item">
                                <p className="fo-key">법인등록번호</p>
                                <div className="fo-value">
                                    <UIInputMask
                                        mask={"999999-9999999"}
                                        className={'tf tf-md w100p'}
                                        value={corpRegNo}
                                        valueChanged={(value) => setCorpRegNo(value)}
                                    />
                                </div>
                            </div>
                            <div className="fo-item req">
                                <p className="fo-key">사업자등록번호</p>
                                <div className="fo-value">
                                    <div className="hz-root hz-gap8 w100p">
                                        <UIInputMask
                                            mask={"999-99-99999"}
                                            className={'tf tf-md w100p'}
                                            value={regBizNo}
                                            valueChanged={(value) => setRegBizNo(value)}
                                        />
                                        <Button color="gray-o" size="md" onClick={() => dupCheck()}>중복확인</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="fo-item fo-m-1-3 req">
                                <p className="fo-key">주소</p>
                                <div className="fo-value">
                                    <div className="address w100p">
                                        <div className="hz-root hz-gap8 w280">
                                            <UIInput className={'hz-item hz-fg tf tf-md'} value={corpZipCd} valueChanged={(data: any) => setCorpZipCd(data)} placeholder={'우편번호'}/>
                                            <Button color="gray-o" size="md" onClick={() => setModalPostIsOpen(true)}>우편번호 찾기</Button>
                                        </div>
                                        <UIInput className={'tf tf-md w100p mt8'} value={corpAddr1} valueChanged={(value) => setCorpAddr1(value)} placeholder={'주소'}/>
                                        <UIInput className={'tf tf-md w100p mt8'} value={corpAddr2} valueChanged={(value) => setCorpAddr2(value)} placeholder={'상세주소'}/>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="fo-item fo-m-1-3">
                                <p className="fo-key">홈페이지</p>
                                <div className="fo-value">
                                    <div className="w100p">
                                        <UIInput className={'tf tf-md w100p'} value={homepageUrl} valueChanged={(value) => setHomepageUrl(value)} placeholder={'홈페이지'}/>
                                    </div>
                                </div>
                            </div>*/}
                            <div className="fo-item fo-m-1-3 req">
                                <p className="fo-key">사업자등록증</p>
                                <div className="fo-value">
                                    <div className="w100p">
                                        <Suspense>
                                            <UI.FileUpload
                                                onCreationComplete={onCreationCompleteBiz}
                                                onUploadComplete={onUploadCompleteBiz}
                                                attrs={{
                                                    MaxTotalFileCount: "1",
                                                    ExtensionAllowOrLimit: "1",
                                                    ExtensionArr: "pdf"
                                                }}
                                                value={bizLicFileValue}
                                            />
                                        </Suspense>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-bottom">
                    <Button color="gray-o" size="md" onClick={() => onClose('1205')}>취소</Button>
                    <Button color="pri" size="md" onClick={() => corpFormCheck()}>저장</Button>
                </div>
            </ModalPopup>
            {/* modal - 우편번호 검색 */}
            <ModalPopup
                open={modalPostIsOpen}
                title="우편번호 검색"
                size="sm"
                onClose={() => onClose('post')}
            >
                <div className="modal-con">
                    <DaumPostcode onComplete={handleComplete} style={postCodeStyle} />
                </div>
            </ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;